import { createReducer, on } from '@ngrx/store';
import { userInitState } from './user.state';

import * as Actions from './user.actions';

export const UserReducer = createReducer(
  userInitState,

  on(Actions.UserLoadingState, (state, { loaderState }) => ({
    ...state,
    loading: loaderState,
  })),

  on(Actions.UserIsLoggedIn, (state, { loggedIn }) => {
    if (loggedIn) {
      return {
        ...state,
        isLoggedIn: true,
        loading: false,
      };
    }
    return {
      ...userInitState,
      isLoggedIn: false,
      loading: false,
    };
  }),

  on(Actions.LoadGlobalProfile, (state) => ({
    ...state,
    loading: true,
  })),

  /** Global profile */
  on(Actions.LoadGlobalProfileSuccess, (state, { account }) => ({
    ...state,
    account: account,
    loading: false,
  })),

  on(Actions.LoadOrgUserData, (state, { orgId }) => ({
    ...state,
    context: {
      ...state.context,
      [orgId]: {
        ...state.context[orgId],
        loading: true,
      },
    },
  })),

  /**
   * Clears `loading` for the org whose profile could not be read, so anything
   * waiting on that org settles on "no profile" instead of waiting forever.
   * `SetFailure` cannot do this: it carries no `orgId`.
   */
  on(Actions.SetOrgUserDataFailure, (state, { orgId }) => ({
    ...state,
    context: {
      ...state.context,
      [orgId]: {
        ...state.context[orgId],
        loading: false,
      },
    },
  })),

  /** Set Data */
  on(Actions.LoadSuccessOrgUserData, (state, { orgId, profile }) => ({
    ...state,
    context: {
      ...state.context,
      [orgId]: {
        ...state.context[orgId],
        profile: {
          ...(state.context[orgId]?.profile ?? {}),
          ...profile,
        },
        loading: false,
      },
    },
  })),

  on(Actions.SetFailure, (state, { error }) => ({
    ...state,
    error: error,
    loading: false,
  })),
);
